<template>
  <v-app>
    <section id="menu-wrapper" :class="{ 'menu-expanded' : $store.state.menuOpen }">
      <side-menu></side-menu>
    </section>

    <section id="content-wrapper" :class="{ 'menu-expanded' : $store.state.menuOpen }">
      <v-toolbar class="header-toolbar" :class="{ 'menu-expanded' : $store.state.menuOpen }" :color="companyPrimaryColor" fixed dense dark>
        <v-toolbar-title class="white--text">Relevant Casting</v-toolbar-title>
      </v-toolbar>

      <section id="content">
        <div class="content-header-extra">
          <div class="header-content clear">
            <div class="header-select">
              <div class="header-select-select">
                <v-select
                  :items="companies"
                  item-text="name"
                  item-value="id"
                  v-on:input="loadActiveCompData()"
                  v-model="activeComp"
                  label="Select"
                  single-line>
                </v-select>
                <br>
              </div>
              <div class="header-select-button"></div>
            </div>
            <div class="header-edit">
              <div class="header-edit-button">
                 <v-btn fab darken color="primary" @click.stop="newCastDialog = true">
                  <v-icon darken>add</v-icon>
                </v-btn>
              </div>
              <div class="header-edit-search">
              </div>
            </div>
          </div>
        </div>

        <v-layout row>
          <v-flex xs12 sm4 >
            <div v-if="loading == false && casting.length > 0">
              <v-card> 
                <v-list two-line>
                  <template v-for="(cast, index) in casting" >
                    <v-list-tile 
                      class="cast" :class="{unpublished: !cast.published}"
                      :key="index"
                      avatar
                    >
                      <v-list-tile-avatar :tile=true>
                        <img :src="cast.Image">
                      </v-list-tile-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title v-html="cast.title" ></v-list-tile-title>
                        <v-list-tile-sub-title v-html="cast.description"></v-list-tile-sub-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-layout row>
                          <v-flex xs6 > 
                            <v-btn flat icon >
                              <v-icon color="grey" @click="deleteCastDialog= true" dark >delete</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-flex xs6>
                            <v-btn flat icon color="grey" @click.stop="editCastitem(index)" >
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </v-flex> 
                        </v-layout>
                      </v-list-tile-action>
                    </v-list-tile>

                    <v-divider
                      v-if="index + 1 < casting.length"
                      :key="`A-${index}`"
                    ></v-divider>

                  </template>
                </v-list>
              
              </v-card>
            </div>
          </v-flex>

          <v-flex id="preview-wrapper" xs12 sm8  style="padding: 0 0 0 20px;">
            <div v-show="loading == false && casting.length > 0" style=" overflow: hidden; border-radius: 0;" >
              <v-toolbar dark :color="companyPrimaryColor">
                <v-toolbar-title class="white--text">Preview</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon @click="previewPrevious()">
                  <v-icon>skip_previous</v-icon>
                </v-btn>

                <v-btn icon v-if="previewPlaying" @click="previewPause()">
                  <v-icon>pause</v-icon>
                </v-btn>

                <v-btn icon v-if="!previewPlaying" @click="previewPlay()">
                  <v-icon>play_arrow</v-icon>
                </v-btn>

                <v-btn icon @click="previewNext()">
                  <v-icon>skip_next</v-icon>
                </v-btn>
              </v-toolbar>
              <relevant-player  v-if="loading == false && casting.length > 0" :compIdPreview="activeComp" :previewHeight="previewHeight"></relevant-player>
            </div>
          </v-flex>
        </v-layout>
      </section>
    </section>

    <!-- / Delete Cast Dialog \ -->
    <v-dialog v-model="deleteCastDialog" scrollable max-width="350">
      <v-card>
        <div class="hogans-modal-header" v-bind:style="{ backgroundColor: companyPrimaryColor}">
          <h2>Cast verwijderen</h2>
          <div class="hogans-modal-header-close" @click="deleteCastDialog = false"></div>
        </div>
        <v-divider></v-divider>

        <v-card-text>Wilt u deze cast definitief verwijderen?</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="hogans-modal-footer clear" >
          <v-btn  class="modal-button-cancel" outline depressed color="#8B93A6" @click="deleteCastDialog = false">Annuleren</v-btn>
          <v-btn class="modal-button-next" dark round :color="companyPrimaryColor" @click="deleteCast(cast.id, index)" >Verwijder cast <v-icon right dark>arrow_forward_ios</v-icon></v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- \ Delete Cast Dialog / -->       

    <!-- / New Cast Dialog \ -->
    <v-dialog v-model="newCastDialog" scrollable max-width="600px">
      <add-cast-form :activeCompData="activeCompData" @newCastDialogChange="newCastDialog = $event" @updateData="loadCasting()"></add-cast-form>
    </v-dialog>
    <!-- \ New Cast Dialog / -->

    <!-- / Edit Cast Dialog \ -->
    <v-dialog v-model="editCastDialog" scrollable max-width="600px">
      <edit-cast-form :selectedCastItem="selectedCastItem" :selectedCastItemOriginal="selectedCastItemOriginal"  @editCastDialogChange="editCastDialog = $event" @updateData="updateCast()"></edit-cast-form>
    </v-dialog>
    <!-- \ Edit Cast Dialog / -->
  </v-app>
</template>


<script>
import db from "../firebase/init";
import { bus } from "../main";
import AddCastForm from "../components/modals/AddCastForm.vue";
import EditCastForm from "../components/modals/EditCastForm.vue";
import RelevantPlayer from "../views/RelevantPlayer.vue";

export default {
  components: {
    "add-cast-form": AddCastForm,
    "edit-cast-form": EditCastForm,
    "relevant-player": RelevantPlayer
  },

  name: "RelevantCasting",
  data: () => ({
    dialog: false,
    deleteCastDialog: false,
    newCastDialog: false,
    editCastDialog: false,
    casting: [],
    loading: true,
    feedback: null,
    activeCompData: {},
    companies: [],
    activeComp: "", 
    selectedCastItem: {},
    selectedCastItemOriginal: {},
    previewHeight: "0px",
    previewPlaying: true,
  }),

  created() {
    this.loadUserComp();
    window.addEventListener("resize", this.calculateWindowHeight);
  },

  methods: {

    previewPrevious(){
      bus.$emit("previewNext");
      this.previewPlaying = true
    },
    previewNext(){
      bus.$emit("previewNext");
      this.previewPlaying = true
    },
    previewPlay(){
      bus.$emit("previewPlay");
      this.previewPlaying = true
    },
    previewPause(){
      bus.$emit("previewPause");
      this.previewPlaying = false
    },

    calculateWindowHeight(){
      let previewWidth = document.getElementById('preview-wrapper').clientWidth;
      let previewHeightNumber = (previewWidth / 16) * 9
      this.previewHeight = previewHeightNumber.toFixed(0)
      bus.$emit("updateWindowHeight");
    },

    editCastitem(index){
      // Nieuws item bewerken. Juiste data in props zetten.
      this.editCastDialog = true
      this.selectedCastItem = _.cloneDeep(this.casting[index]);
      this.selectedCastItemOriginal = _.cloneDeep(this.selectedCastItem);
    },

    updateCast(){
      // Data updaten na toevoegen of wijzigen van nieuws
      this.selectedCastItem = {}
      this.selectedCastItemOriginal = {}
      this.loadCasting()
    },
    // formatDate(){
    //   // let castingCreateDate = string; 
    //   this.casting.createDate = moment().format("YYYY-MM-DD");
    // },
    // moment(casting.createDate.seconds).unix.format(DD-MM-YYYY)

    loadCasting() {
      bus.$emit("reloadCasting");
      db.collection("Casting")
      .where("company","==", this.activeComp)
      // .orderBy("createDate","desc")
      .get()
      .then(snap => {
        this.casting = [];
        snap.forEach(doc => {
            let casting = doc.data();
            casting.id = doc.id;
            casting.status = "hide";
            casting.startDate = moment.unix(doc.data().startDate.seconds).format("YYYY-MM-DD");
            casting.endDate = moment.unix(doc.data().endDate.seconds).format("YYYY-MM-DD");
            casting.delay = doc.data().delay / 1000;
            this.casting.push(casting);
        });
      })
      
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
    },  

    // casts verwijderen
    deleteCast(id, index){
      console.log("i was deleted doc id:" + id + "index is " + index )
      db.collection("Casting").doc(id).delete()
      .then(() => {
        console.log("Document successfully deleted!");
        this.casting.splice(index,1),
        this.deleteCastDialog = false
      })
      .catch(error => {
        console.error("Error removing document: ", error);
      });
    },

    // casts editen
    editCast(id){
      console.log("i was edited :" + id)
    },

    loadUserComp() {
      console.log("loadUserComp ")
      let userCompanies = this.userCompanies;

      let vm = this;
      this.companies = [];
      let getUserCompData = getUserComp();

      async function getUserComp() {
        if(vm.userRole == 'superadmin'){
          await db.collection("companies")
            .get()
            .then(snap => {
              snap.forEach(doc => {
                let company = {};
                company.name = doc.data().name;
                company.id = doc.id;
                vm.companies.push(company);
              });
            })
        }
        else {
          for (const company of userCompanies) {
            await db.collection("companies")
            .doc(company)
            .get()
            .then(doc => {
              let company = {};
              company.name = doc.data().name;
              company.id = doc.id;
              vm.companies.push(company);
            })
          }
        }
        vm.activeComp = vm.companies[0].id;
        vm.loadActiveCompData();
        vm.loadCasting();
      }
    },
 
    loadActiveCompData() {
      this.loading = true;
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
          this.selectedLanguage = this.activeCompDataOriginal.languages[0]
        })
        .then(() => {
          this.calculateWindowHeight()
          this.loading = false;
        })
        .catch(error => {
          this.calculateWindowHeight()
          this.loading = false;
          console.log("Error getting document:", error);
        });
        this.loadCasting();
    },
  },
  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
  
    changed() {
      if (_.isEqual(this.activeCompData, this.activeCompDataOriginal) == false) {
        return true;
      } else {
        return false;
      }
    },

  }
};
</script>

<style>

#preview-wrapper #page-wrapper{
  height: auto;
}
.cast.unpublished{
  opacity: .3;
}

.send-survey-button-preview {
  font-family: "Sofia Pro", sans-serif;
  position: fixed;
  right: 300px;
  bottom: 50px;
  padding: 12px 55px 14px 15px;
  height: 45px;
  text-align: left;
  color: #ffffff;
  font-weight: 600;
  background: url("../assets/icons/next-button-white.svg") no-repeat center right 4px;
}

.send-survey-button-preview .v-btn__content {
  font-weight: 600;
}

.send-survey-button-preview:hover,
.send-survey-button-preview:active,
.send-survey-button-preview:focus {
  position: fixed;
  right: 300px;
  bottom: 50px;
}

.custom-table ul {
  padding: 5px 0;
  list-style: square;
}

.custom-table li{
  display: list-item;
}
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
p.settings-tab-introtext {
  padding: 10px 0 0 0;
  font-size: 16px;
}

.email-preview {
  padding: 20px 0;
  background-color: #f6f7fb;
}

.email-wrapper {
  width: 560px;
  margin: 20px auto;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e8e9ee;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
}
.user-permissions-table {
  padding: 3px 0;
}

.user-permissions-table p {
  padding: 3px 0 0 0;
  margin: 0;
  font-weight: 600;
  font-size: 12px;
}

.user-permissions-table ul {
  padding: 0 0 0 14px;
}

.user-permissions-table ul li {
  font-size: 12px;
}

.tab-inner-wrapper.padding {
  padding: 20px;
  position: relative;
}

.tab-header.table {
  padding: 20px 20px 0 20px;
}

.first-item-button {
  padding: 100px 0;
}
</style>